var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.appTheme)?_c('img',{attrs:{"width":"30","src":require("../../../../static/website/images/noData.svg"),"alt":"Icon"}}):_c('img',{attrs:{"width":"30","src":require("../../../../static/website/images/light-bg-record.svg"),"alt":"Icon"}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.text || 'No Data')}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fbf1375","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/website/shared/no-data.vue
// module id = null
// module chunks = 